module.exports = __webpack_public_path__ + "img/DeleteImg.57b37aea.png";